"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FingerDrawSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M24.535,13.47,16,12.382V5a3,3,0,0,0-6,0V20s-3.72-1.73-4-1.829A3,3,0,0,0,3.2,23.4l8,6A2.983,2.983,0,0,0,13,30h11.7a2,2,0,0,0,1.985-1.752l1.29-10.318A4,4,0,0,0,24.535,13.47Z"/><path d="M29,10a1,1,0,0,1-.858-.483A9.971,9.971,0,0,0,20,5H19a1,1,0,0,1,0-2h1a12.009,12.009,0,0,1,9.857,5.485A1,1,0,0,1,29,10Z"/>';
var FingerDrawSVG = function FingerDrawSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FingerDrawSVG = FingerDrawSVG;
FingerDrawSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FingerDrawSVG);
exports.default = _default;